var exports = {
  "container": "x127c5a35--7b5997--container",
  "blue": "x127c5a35--7b5997--blue",
  "green": "x127c5a35--7b5997--green",
  "gray": "x127c5a35--7b5997--gray",
};

module.exports = exports;
